import { render, staticRenderFns } from "./ReviewOtherUser.vue?vue&type=template&id=3b48039c&scoped=true&"
import script from "./ReviewOtherUser.vue?vue&type=script&lang=js&"
export * from "./ReviewOtherUser.vue?vue&type=script&lang=js&"
import style0 from "./ReviewOtherUser.vue?vue&type=style&index=0&id=3b48039c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48039c",
  null
  
)

export default component.exports